// Reveals [data-reveal] elements as they scroll into view. Skipped entirely for reduced motion.
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('js-reveal')) return;
  const targets = document.querySelectorAll('[data-reveal]');
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );
  targets.forEach((el) => observer.observe(el));
})();
